import React from "react";

const UserMessage = ({ error }) => {
  return (
    <div>
      <p>{error}</p>
    </div>
  );
};

export default UserMessage;
